module.exports = __webpack_public_path__ + "static/media/ico_rule.adca8ea9.svg";